import { AuthContext } from '@repo-level/core-front';
import { useCallback, useContext, useEffect } from 'react';
import { syncUserGroupAndLSAbVersions } from '../helpers/syncUserGroupAndLSAbVersions';

export const useSyncABTestsUserGroup = () => {
  const { user, refreshUser } = useContext(AuthContext);

  const sync = useCallback(async () => {
    if (!user) return;

    try {
      const isUpdated = await syncUserGroupAndLSAbVersions(user);

      if (isUpdated) {
        await refreshUser();
      }
    } catch (err) {
      console.error('useSyncABTestsUserGroup failed:', err);
    }
  }, [user, refreshUser]);

  useEffect(() => {
    sync();
  }, [sync]);
};
